export enum RegistrationType {
  GOOGLE,
  GITHUB,
  EMAIL

}
